'use strict';

function triggerRemove(e, product, oldEventBus, boxProducts) {
    if (e.which === 13 || e.which === 32) {
        oldEventBus.$emit('removeProductFromBox', product.id);
        if (boxProducts.value.length === 0) {
            $('.product-grid .product-tile a').first().focus();
        } else {
            $('.mobile-selected-products-container .remove-product').first().focus();
        }
    }
}

module.exports = {
    triggerRemove
};
